import React from 'react';
import ReactDOM from 'react-dom';
import mixin from 'react-mixin';
import { forwardPropsToState } from '../../../utils/react_utils';

@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.InputComponentMixin)
@forwardPropsToState([{ prop: 'value' }])
export default class InputText extends React.Component {
	componentDidMount() {
		if (this.props.mask) {
			const $input = $(ReactDOM.findDOMNode(this.refs.input));
			let newMask = '';

			if (['cpf', 'cnpj', 'telefone', 'celular', 'cep'].includes(this.props.mask.toLocaleLowerCase())) {
				newMask = this.props.mask.toLocaleLowerCase();
				newMask = Realize.i18n.t(`masks.${newMask}`);
			}
			else
				newMask = this.props.mask.replace(/9/g, "0");

			if (newMask.match(/\[\d\]/g))
				newMask = newMask.replace(/\[\d\]/g, "9");

			$input.mask(newMask, {clearIfNotMatch: true});
			this.props.onChange(null, $input.val(), this);
		}
	}

	componentWillUpdate(nextProps, nextState) {
		let { mask } = this.props;

		if (mask !== nextProps.mask) {
			let newMask = nextProps.mask;
			const $input = $(ReactDOM.findDOMNode(this.refs.input));

			/* istanbul ignore else */
			if (newMask) {
				if (['cpf', 'cnpj', 'telefone', 'celular', 'cep'].includes(newMask.toLocaleLowerCase()))
					newMask = Realize.i18n.t(`masks.${newMask}`);

				newMask = newMask.replace(/9/g, "0");

				if (newMask.match(/\[\d\]/g))
					newMask = newMask.replace(/\[\d\]/g, "9");

				$input.mask(newMask, { clearIfNotMatch: true});
			}

			this.props.onChange(null, $input.val(), this);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		let { value, mask } = this.props;
		const $input = $(ReactDOM.findDOMNode(this.refs.input));

		if (prevProps.value !== value && mask) {
			this.props.onChange(null, $input.val(), this);
		}

		if (prevProps.mask !== mask) {
			if (!mask) {
				$input.attr("maxlength", this.props.maxLength);
				$input.unmask();
			}

			this.props.onChange(null, $input.val(), this);
		}
	}

	returnValue() {
		const { value } = this.state;

		if (value !== null && value !== undefined) {
			const { mask, maxLength } = this.props;
			const $input = $(ReactDOM.findDOMNode(this.refs.input));

			if (mask && $input.length)  {
				return $input.masked(value);
			}

			if (maxLength) {
				return value.toString().substr(0, maxLength);
			}

			return value;
		}

		return "";
	}

	getProps() {
		return { onChange: this.handleChange.bind(this) }
		//onChange: this._handleChange.bind(this)
	}

	handleChange(event) {
		const { maxLength } = this.props;
		let newValue = event.target.value;

		if (this.props.mask && this.props.mask.includes('(99) [9]9999-9999')) {
			let newMask = newValue.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
			const $input = $(ReactDOM.findDOMNode(this.refs.input));
			
			$input.mask(newMask, { clearIfNotMatch: true});
		}

		newValue = typeof newValue == "string" ? newValue.toString().substr(0, maxLength) : newValue;
		this.props.onChange(event, newValue, this);

		if (!event.isDefaultPrevented()) { 
			this.setState({ value: newValue });
		}
	}

	handleBlur(event) {
		const { value } = this.state;
		const { mask } = this.props;
		const valueDom = event.target.value;

		/* istanbul ignore else */
		if (mask && value !== valueDom && valueDom === "") {
			this.props.onChange(event, "", this);
		}

		if (this.props.onBlur !== undefined) {
			this.props.onBlur(event);
		}
	}

	handleFocus(event) {
		this.props.onFocus(event);
	}
	
	validateActionsField() {
		let actionsFields = this.props.actions;

		return (actionsFields && actionsFields.length > 0) ? ' actions-field' : '';
	}

	render() {
		return (
			<input
				{...this.props}
				{...this.getProps()}
				id={this.props.id}
				aria-required={this.props.required}
				placeholder={this.getPlaceholder()}
				className={this.inputClassName() + 'input-text ' + this.validateActionsField()}
				onFocus={this.handleFocus.bind(this)}
				onBlur={this.handleBlur.bind(this)}
				value={this.returnValue()}
				type="text"
				ref="input"
			/>
		);
	}
}
